/**
 * External dependencies
 */
 import classnames from 'classnames';

 /**
	* WordPress dependencies
	*/
 import { __ } from '@wordpress/i18n';
 import { Component, Fragment } from '@wordpress/element';
 import { BlockPreview, BlockControls } from '@wordpress/block-editor';
 import {
	 MenuItem,
	 MenuGroup,
	 Popover,
	 Toolbar,
	 ToolbarGroup,
	 DropdownMenu,
	 ToolbarItem,
	 Icon,
 } from '@wordpress/components';

 import icons from '../../../blocks/icons';

 function MixBlendControl ( props ) {
	const {
		attributes,
		setAttributes,
	} = props;

	const {
		mixBlendMode,
	} = attributes;

	const filterControls = [
		{
			icon: null,
			/* translators: mix blend mode */
			title: __( 'No mix blend mode', 'eedee-components' ),
			slug: 'none',
			onClick: () => {
				setAttributes( { mixBlendMode: 'none' } );
			},
			isActive: mixBlendMode === 'none',
		},
		{
			icon: <Icon icon={ icons.difference } />,
			/* translators: mix blend mode */
			title: __( 'Difference', 'eedee-components' ),
			slug: 'difference',
			onClick: () => {
				setAttributes( { mixBlendMode: 'difference' } );
			},
			isActive: mixBlendMode === 'difference',
		},
		{
			icon: <Icon icon={ icons.lighten } />,
			/* translators: mix blend mode */
			title: __( 'Lighten', 'eedee-components' ),
			slug: 'lighten',
			onClick: () => {
				setAttributes( { mixBlendMode: 'lighten' } );
			},
			isActive: mixBlendMode === 'lighten',
		},
		{
			icon: <Icon icon={ icons.darken } />,
			/* translators: mix blend mode */
			title: __( 'Darken', 'eedee-components' ),
			slug: 'darken',
			onClick: () => {
				setAttributes( { mixBlendMode: 'darken' } );
			},
			isActive: mixBlendMode === 'darken',
		},
	];

	return (
		<BlockControls>
			<ToolbarGroup label={ __( 'Mix Blend Mode Toolbar', 'eedee-components' ) }>
				<ToolbarItem>
					{ ( toolbarItemHTMLProps ) => (
						<DropdownMenu
							icon={ <Icon icon={ icons.mix } /> }
							label={ __( 'Apply Mix Blend Filter to Fixed Content', 'eedee-components' ) }
							toggleProps={ toolbarItemHTMLProps }
							className={ classnames( 'eedee-component-mix-blend-filter', ( 'none' !== mixBlendMode ) ? 'has-filter' : '' ) }
							controls={ filterControls }
						>
						</DropdownMenu>
					) }
				</ToolbarItem>
			</ToolbarGroup>
		</BlockControls>
	);

 }
 export default MixBlendControl;
